import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useDashboard = (params) => {
    const [loading, setLoading] = useState(true);
    const [counters, setCounters] = useState({});

    useEffect(() => {
        const fetchDashboardData = async () => {
            setLoading(true);
            try {
                const { data } = await api.get("/dashboard/stats", { params });
                setCounters(data);
                setLoading(false);
            } catch (err) {
                setLoading(false);
                toastError(err);
            }
        };
        fetchDashboardData();
    }, [params]);

    return { counters, loading };
};

export default useDashboard;
